.content {
	overflow: hidden;
}
